import { select } from 'd3-selection';
import { scaleLinear } from 'd3-scale';
import { axisBottom } from 'd3-axis';

const defaults = {
  target: '#barcode',
  data: [],
  height: 70,
  colors: ['#f0f0f4', '#2a8389']
};

export default class BarCode {
  constructor(config) {
    this.set(config);
    this.draw();
  }

  set(config) {
    Object.assign(this, defaults, config);
  }

  draw() {
    const { data, target, height, colors } = this;
    const container = select(`${target}`).html('');
    const width = container.node().getBoundingClientRect().width;

    const xScale = scaleLinear()
      .domain([0, data.values.length])
      .range([0, width]);

    const colorScale = scaleLinear()
      .domain([0, 100])
      .range(colors);

    const rectWidth = (width / data.values.length) + 1;

    const xAxis = axisBottom(xScale)
      .tickSize(0)
      .tickPadding(10)
      .tickValues(xScale.ticks(5).filter(d => d / xScale.domain()[1] < 0.95).concat(xScale.domain()[1]))
      .tickFormat(d => this.pretty(d));

    const svg = container.append('svg')
      .attr('width', width)
      .attr('height', height + 20);

    svg.append('g')
      .attr('class', 'xAxis')
      .attr('transform', 'translate(0,' + height + ')')
      .call(xAxis)
      .selectAll('text')
      .each(function (d, i, p) {
        if (i === 0) { select(this).attr('text-anchor', 'start'); }
        if (i === p.length - 1) { select(this).attr('text-anchor', 'end'); }
      });

    svg.append('rect')
      .attr('width', width)
      .attr('height', height)
      .attr('fill', '#f0f0f4');

    svg.append('g')
      .selectAll('rect')
      .data(data.values.map((d, i) => { d.index = i; return d;}).filter(d => d.value))
      .enter()
      .append('rect')
      .attr('width', rectWidth)
      .attr('height', height)
      .attr('x', d => xScale(d.index))
      .attr('y', '0')
      .attr('fill', d => {
        if (d.length) {
          return colorScale(d.value / d.length * 100);
        } else {
          return '#fff';
        }
      });
  }

  pretty(number) {
    number = number.toString().split('.');
    number = number[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (number[1] ? ',' + number[1] : '');
    return number;
  }

  update() {
    this.draw();
  }
}
